import { useCallback } from 'react';

import { type OrderingContext } from '@order/features/ordering';

import { usePlacedOrdersCounter } from '../../../../context/PlacedOrdersCounter';
import { useLocalOrderHistory } from '../../../../hooks';

export const usePostOrderHistory = () => {
  const { incrementPlacedOrdersCounter } = usePlacedOrdersCounter();
  const { addToLocalOrderHistory } = useLocalOrderHistory();

  const handlePostOrderHistory = useCallback(
    ({ context }: { context: OrderingContext }) => {
      const { orderId } = context;

      if (!orderId) return;

      addToLocalOrderHistory({ orderId });
      incrementPlacedOrdersCounter();
    },
    [addToLocalOrderHistory, incrementPlacedOrdersCounter],
  );

  // ─────────────────────────────────────────────────────────────────────

  return { handlePostOrderHistory };
};
